
export default {
  props: {
    item: Object,
  },
  mounted() {
    this.$store.commit('layout/setShouldUpdateFrameScrollHeight')
  },
}
